import { gql } from '@apollo/client';
import { DOCUMENT_FRAGMENT } from './documentFragment';
import { BANK_ACCOUNT_ADDRESS_FRAGMENT } from './bankAccountAddressFragment';

export const BANK_ACCOUNT_FRAGMENT = gql`
  fragment BankAccountFragment on BankAccount {
    id
    authorizedPersonTitle
    bankName
    routingNumber
    signature
    visibleBankAccountNumber
    achAuthDocument {
      ...DocumentFragment
    }
    address {
      ...BankAccountAddressFragment
    }
  }
  ${DOCUMENT_FRAGMENT}
  ${BANK_ACCOUNT_ADDRESS_FRAGMENT}
`;
